var CryptoJS = require("crypto-js");

const secretKey = '8F4D85B8DDD8B46BA9389757F5B14';

export function encryption(data: string) {
    return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
}

export function decode(data: string) {
    const bytes = CryptoJS.AES.decrypt(data, secretKey);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
}